function LayoutLoad(): JSX.Element {
    return (
        <section className="root-container">
            <header className={"header"}></header>
            <main className="root__main"></main>
        </section>
    )
}

export default LayoutLoad
